<template>
  <div class="page flex-col">
    <div class="block_1 flex-col">

      <div class="group_7 flex-col">

        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-if="source==='nmg'">
              <img class="pic" src="../../assets/index/carousel_shop.jpg" alt="">
            </div>
            <div class="swiper-slide" v-if="source!=='nmg' && source!=='gz'">
              <img class="pic" src="../../assets/index/sc20.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img class="pic" src="../../assets/index/carousel_car.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img class="pic" src="../../assets/index/carousel_jf15.png" alt="">
            </div>
            <div class="swiper-slide" v-if="source==='sd'">
              <img class="pic" src="../../assets/index/carousel_school.jpg" alt="">
            </div>
          </div>
          <!-- 如果需要分页器 -->
          <div class="swiper-pagination"></div>
          <!-- 如果需要导航按钮 -->
        </div>

        <div class="image-wrapper_2 flex-row justify-between">
        </div>
<!--                <img-->
<!--                  class="image_4"-->
<!--                  referrerpolicy="no-referrer"-->
<!--                  src="https://lanhu-oss.lanhuapp.com/SketchPngc864ddf1836a5232200e55ffbe6663eb6e22b6da9d689d42c131c4ec69624d40"-->
<!--                />-->
<!--                <div class="group_3 flex-row">-->
<!--                  <div class="image-text_3 flex-row justify-between">-->
<!--                    <div class="block_2 flex-col">-->
<!--                      <span class="text_3">公告</span>-->

<!--                    </div>-->
<!--                    <div style=" width:340px;overflow: hidden; position: relative;">-->
<!--                      <span class="text-group_1" >{{notice_text}}</span>-->
<!--                    </div>-->

<!--                  </div>-->
<!--                </div>-->
        <van-notice-bar
          color="#fff"
          left-icon="volume"
          :text="notice_text"
        />
        <div class="box_14 flex-row justify-between">
          <div class="group_5 flex-col"></div>
          <div class="image-text_4 flex-row justify-between">
            <span class="text-group_2">精品权益</span>
            <div class="section_3 flex-col"></div>
          </div>
        </div>
      </div>
      <div class="section_4 flex-col">
        <div class="box_15 flex-col">
          <div class="box_2 flex-col" v-if="showShop">
            <div class="text-group_9 flex-col">
              <span class="text_4">本地生活(商超版)</span>
              <span class="text_5">月月领热门商超券</span>
            </div>
            <div class="text-wrapper_1 flex-col">
              <span class="text_6" @click="jumpHyLink(1)">立即查看</span>
            </div>
            <div class="box_3 flex-col">
              <div class="section_5 flex-col">
                <div class="text-wrapper_2 flex-col">
                  <span class="text_7">商超版</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box_4 flex-col">
            <div class="text-group_10 flex-col">
              <span class="text_8">本地生活(出行版)</span>
              <span class="text_9"
              >月月领热门出行代金券</span
              >
            </div>
            <div class="text-wrapper_3 flex-col">
              <span class="text_10" @click="jumpHyLink(2)">立即查看</span>
            </div>
            <div class="section_6 flex-col">

              <div class="box_5 flex-col">
                <div class="text-wrapper_4 flex-col">
                  <span class="text_11">出行版</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box_6 flex-col" v-if="showJf">
            <div class="text-group_11 flex-col">
              <span class="text_12">本地生活(公共缴费版)</span>
              <span class="text_13">月月领水电燃热门代金券</span>
            </div>
            <div class="text-wrapper_5 flex-col">
              <span class="text_14" @click="jumpHyLink(3)">立即查看</span>
            </div>
            <div class="group_6 flex-col">
              <div class="box_7 flex-col">
                <div class="text-wrapper_13 flex-col">
                  <span class="text_15">公共缴费版</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box_8 flex-col" v-if="showFood">
            <div class="text-group_12 flex-col">
              <span class="text_16">本地生活(美食版)</span>
              <span class="text_17">月月领1张10元、1张15元美食代金券</span>
            </div>
            <div class="text-wrapper_7 flex-col">
              <span class="text_18" @click="jumpHyLink(4)">立即查看</span>
            </div>
            <div class="block_3 flex-col">
              <div class="section_7 flex-col">
                <div class="text-wrapper_8 flex-col">
                  <span class="text_19">美食版</span>
                </div>
              </div>
            </div>
          </div>
          <div class="box_8 flex-col" v-if="showSchool">
            <div class="text-group_12 flex-col">
              <span class="text_16">本地生活(校园版)</span>
              <span class="text_17">月月领校园代金券</span>
            </div>
            <div class="text-wrapper_7 flex-col">
              <span class="text_18" @click="jumpHyLink(7)">立即查看</span>
            </div>
            <div class="block_3 flex-col">
              <div class="section_7 flex-col">
                <div class="text-wrapper_8 flex-col">
                  <span class="text_19">校园版</span>
                </div>
              </div>
            </div>
          </div>
            <div class="box_9 flex-col" v-if="show20">
              <div class="text-group_13 flex-col">
                <span class="text_20">30元会员</span>
                <span class="text_21">五大精品权益，每月任选一种</span>
              </div>
              <div class="text-wrapper_9 flex-col">
                <span class="text_22" @click="jumpHyLink(5)">立即查看</span>
              </div>
              <div class="block_4 flex-col">
                <div class="text-wrapper_10 flex-col">
                  <span class="text_23">精品权益</span>
                </div>
              </div>
            </div>
            <div class="box_10 flex-col" v-if="show30">
              <div class="text-group_14 flex-col">
                <span class="text_24">50元会员</span>
                <span class="text_25">五大精品权益，每月任选一种</span>
              </div>
              <div class="text-wrapper_11 flex-col">
                <span class="text_26" @click="jumpHyLink(6)">立即查看</span>
              </div>
              <div class="box_11 flex-col">
                <div class="text-wrapper_12 flex-col">
                  <span class="text_27">精品权益</span>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showMobileBtn" :close-on-click-overlay="false" round position="center" :style="{width: '85%', height: '20%' }">
      <div style="padding: 1rem 0;">
        <van-field v-model="tel" type="tel" center clearable label="手机号" placeholder="请输入手机号">
          <template #button>
            <van-button @click="onTelSet" size="small" type="primary">确定</van-button>
          </template>
        </van-field>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Swiper from "swiper";
import {
  getColumns,
  getCouponList,
  getuserInfo,
  getTokenForTicket,
  getTokenByOpenid,
  getOauth2AccessTokenNew,
  wtdecrypt,
  getNotice,
} from "@/api/user";
import {mapState} from "vuex";
import {getItem, setItem, getUrlParam} from "@/utils/storage";
import {Toast, Dialog} from "vant";
import {isWXBrowser, getWechatCode} from "@/api/getcode";

export default {
  data() {
    return {
      constants: {},
      source: '',
      v: '',
      showJf: true,
      showCx: true,
      showShop: true,
      show20: false,
      show30: false,
      showFood: true,
      notice_text:'',
      showSchool:true,
      areaId:"",
      location: null, // 位置信息
      tel: "",
      openid: "",
      showMobileBtn: false,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {
    $route() {
      location.reload();
      // this.$dialog.close();
      // this.show = false;
    },
  },
  async mounted() {

    this.source=this.getParam("source");
    this.source=this.source==='undefined'||this.source===''?'sd':this.source;
    console.log('source-value:',this.source);
    sessionStorage.setItem("source", this.source);

    this.v = this.getParam('v')

    switch (this.source) {
      case "gz":
        this.show20 = false;
        this.show30 = false;
        this.showFood=false;
        this.showShop=false;
        this.showSchool=false;
        break;
      case "js":
        this.show20 = false;
        this.show30 = false;
        this.showFood=false;
        this.showSchool=false;
        break;
      case "sd":
        this.show20 = false;
        this.show30 = false;
        this.showFood=false;
        break;
      case "nmg":
        if(this.v==='p2')
          this.showJf=false;
          this.showSchool=false;
        break;
      default:
        break;
    }
    if (this.source === 'js' || this.source === 'gz') {
      this.show20 = false;
      this.show30 = false;
    }

    //轮播图
    new Swiper('.swiper-container', {
      slidesPerView: 1, // 每个视口显示1.5个滑块
      centeredSlides: true, // 使当前滑块居中
      spaceBetween: 30, // 滑块之间的间距
      autoplay: {
        delay: 2000, // 每次切换的间隔时间，单位为毫秒
        disableOnInteraction: false, // 用户操作后是否继续自动播放
      },
      loop: true, // 循环模式
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });

    const hasLoginInfo = await this.initLogin();
    if (hasLoginInfo) {
      await this.userinfo();
    }

    if (getItem('localtion') && getItem('localtion').id){
      this.areaId = getItem('localtion').id
    }
    // var datas = await getNotice({ noticeType: "1", cityCode: this.source==='sd'?'16':'0' });
    var datas = await getNotice({ noticeType: "1", cityCode: this.areaId});

    if (datas.data.code == "0") {
      this.notice_text = datas.data.data;
    }
  },
  methods: {
    //功能点位跳转
    jumpHyLink(type) {
      switch (type) {
        case 1:
          this.$router.push({
            name: 'shop'
          });
          break;
        case 2:
          this.$router.push({
            name: 'hy'
          });
          break;
        case 3:
          this.$router.push({
            name: 'jfb'
          });
          break;
        case 4:
          this.$router.push({
            name: 'ms'
          });
          break;
        case 5:
          this.$router.push({
            name: 'vip51'
          });
          break;
        case 6:
          this.$router.push({
            name: 'vip30'
          });
          break;
        case 7:
          this.$router.push({
            name: 'school'
          });
          break;
        default:
          break;
      }
    },

    //获取ticket值
    getParam(param) {
      try {
        var url = window.location.href; //获取当前url
        // var dz_url = url.split('#')[1]; //获取#/之后的字符串
        var dz_url = url.split("#")[0]; //获取#/之前的字符串
        var cs = dz_url.split("?")[1]; //获取?之后的参数字符串
        var cs_arr = cs.split("&"); //参数字符串分割为数组
        var cs = {};
        for (var i = 0; i < cs_arr.length; i++) {
          //遍历数组，拿到json对象
          cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
        }
        if (param === 'ticket') {
          return decodeURIComponent(cs.ticket);
        } else if (param === 'value') {
          return decodeURIComponent(cs.value);
        } else if (param === 'v') {
          return decodeURIComponent(cs.v);
        }else if (param === 'source') {
          return decodeURIComponent(cs.source);
        }
        return '';

      } catch (e) {
        return "";
      }
    },

    async getToken(ticket, value) {
      let parma = {
        ticket: ticket,
        value: value,
      };
      const {data} = await getTokenForTicket(parma);
      var dats = {
        token: data.data,
      };
      this.$store.dispatch("AddUser", dats);
      return data.data;
    },
    async initLogin() {
      console.log('session.ticket', sessionStorage.getItem("ticket"))
      if (sessionStorage.getItem("ticket") === "1") {
        return true;
      }
      var ticket = this.getParam('ticket');
      console.log('获取缓存-ticket:', ticket);
      var value = this.getParam('value');
      console.log('获取value:', value);
      if (ticket !== "" || value !== "") {
        await this.getToken(ticket, value);
        sessionStorage.setItem("ticket", "1");
        return true;
      }
      if (!isWXBrowser) {
        return true;
      }
      const openid = await this.getWechatOpenid();
      if (!openid) {
        return false;
      }
      this.openid = openid;
      return this.loginByOpenid(openid);
    },
    async getWechatOpenid() {
      const storedOpenId = localStorage.getItem('openId');
      if (storedOpenId) {
        return storedOpenId;
      }
      const code = getWechatCode();
      if (!code) {
        return "";
      }
      const { data } = await getOauth2AccessTokenNew({ code });
      if (data.code === 0 && data.data) {
        localStorage.setItem('openId', data.data);
        return data.data;
      }
      Toast.fail(data.msg || '微信授权失败');
      return "";
    },
    async loginByOpenid(openid) {
      const { data } = await getTokenByOpenid({ openid });
      if (data.code == 0 && data.data) {
        await this.$store.dispatch("AddUser", { token: data.data });
        return true;
      }
      this.showMobileBtn = true;
      return false;
    },
    async onTelSet() {
      const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/;
      if (this.tel === '' || this.tel === undefined || this.tel === null || !reg.test(this.tel)) {
        Dialog.alert({
          message: '手机号输入不正确，请检查',
        })
        return false
      }
      if (!this.openid) {
        Dialog.alert({
          message: '未获取到微信信息，请重新进入页面',
        })
        return false
      }
      const { data } = await wtdecrypt({
        mobile: this.tel,
        openid: this.openid,
      });
      if (data.code == 0 && data.data) {
        await this.$store.dispatch("AddUser", { token: data.data });
        this.showMobileBtn = false;
        await this.userinfo();
        return true;
      }
      Dialog.alert({
        message: data.msg || '登录失败，请检查手机号',
      })
      return false;
    },
    async userinfo() {
      const { data } = await getuserInfo();
      // 如果token过期 -code -1  msg登录过期
      if (data.code == -1){
        Dialog.alert({
          title: '登录过期',
          message: '请重新获取登录信息',
        }).then(async res => {
          //如果ticket在运行期间存在 就不在请求
          var ticket = this.getParam('ticket');
          var value = this.getParam('value');
          if (ticket != "" || value != "") {
            var mobile = await this.getToken(ticket, value);
            sessionStorage.setItem("ticket", "1");
          }
        })
      }


      if(this.source==='top'){
        console.log("user-data",data);
        if(data.data.usrProv==="17"){
          //山东
          this.source='sd';
          this.showFire=true;
        }
        // else if(data.data.usrProv==="10"){
        //     //内蒙古
        //     this.source='nmg';
        // }

        else{
          this.source = 'newPlat';
        }

        sessionStorage.setItem("source",this.source);
        console.log("分发页面----",this.source)

         if(this.source==='newPlat'){
          //跳转新平台
          console.log('新平台地址...https://wo.kurioss.com?value='+encodeURIComponent(data.data.platValue))
          var hrefUrl = 'https://wo.kurioss.com?value='+encodeURIComponent(data.data.platValue);
          console.log('跳转新平台',hrefUrl)
          window.location.href=hrefUrl;
          return;
        }
      }

      sessionStorage.setItem("source",this.source);
    },
  }
};

</script>
<style>
#app {
  height: 100%;
  overflow: auto;
}

.layout-container {
  height: 100%;
  overflow: auto;
}

.van-notice-bar {
  margin-top:20px;
  padding-left: 0.1rem;
  margin-left: 0.23rem;
  border-radius: 0.3rem;
  width: 8.31rem;
  height: 0.6rem;
  font-size: 0.35rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  background: #ff6c6ce6;
}
.van-notice-bar__left-icon, .van-notice-bar__right-icon{
  margin-right: 0.2rem;
  color: rgb(41,156,254);
  width: 0.6rem;
  background: #fff;
  border-radius: 0.3rem;
  padding: 0.05rem 0 0.05rem 0.15rem
}
</style>
<style scoped lang="less">


.page {
  //background-color: rgba(255, 255, 255, 1);
  position: relative;
  overflow: auto;
  //height: 100%;
  background: linear-gradient(180deg, #CEE9FC, #FF6F95) 100% no-repeat;

  .swiper-container {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 18px;
    //background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.3s ease; /* 平滑过渡效果 */
  }

  .swiper-slide img {
    width: 100%;
    height: auto;
  }
  //.swiper-container {
  //  width: 100%;
  //  height: 100%;
  //    position: relative;
  //    overflow: hidden;
  //  //height: 300px; /* 根据需要调整高度 */
  //}
  //
  //.swiper-slide {
  //  text-align: center;
  //  font-size: 18px;
  //  background: #fff;
  //  display: flex;
  //  justify-content: center;
  //  align-items: center;
  //  transition: transform 0.6s ease;
  //  filter: blur(10px); /* 默认所有图片都模糊 */
  //}
  //
  //.swiper-slide-active,
  //.swiper-slide-prev,
  //.swiper-slide-next {
  //  filter: blur(0); /* 当前活动的滑块和相邻的滑块不模糊 */
  //}
  //
  //.swiper-slide-active {
  //  transform: scale(1.2); /* 让当前活动的滑块放大一点 */
  //}

  .block_1 {

    background-size: 100% 100%;
    padding-bottom: 14px;
    height: 100%;

    .group_7 {
      position: relative;
      padding: 29px 13px 10px 12px;
      opacity: 1;

      .image-wrapper_2 {
        width: 350px;

        .image_2 {
          width: 174px;
          height: 98px;
        }

        .image_3 {
          width: 174px;
          height: 98px;
        }
      }

      .image_4 {
        width: 64px;
        height: 5px;
        align-self: center;
        margin-top: 25px;
      }

      .group_3 {
        background: url('../../assets/index/notice-bg@2x.png') 100% no-repeat;
        background-size: 100% 100%;
        margin: 16px 0 0 0;

        .image-text_3 {
          width: 340px;
          margin: 0 134px 0 -5px;

          .block_2 {
            background-size: 100% 100%;
            position: relative;
            padding: 4px 18px 4px 40px;

            .text_3 {
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 14px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              white-space: nowrap;
              line-height: 22px;
            }

            .label_3 {
              position: absolute;
              left: -11px;
              top: -4px;
              width: 33px;
              height: 36px;
            }
          }

          .text-group_1 {
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 14px;
            font-weight: normal;
            text-align: left;
            white-space: nowrap;
            line-height: 22px;
            margin-top: 4px;
            position: absolute;
            animation: scroll 20s linear infinite;
          }
        }
      }

      .box_14 {
        width: 138px;
        margin: 8px 211px 0 1px;

        .group_5 {
          width: 16px;
          height: 15px;
          background: url('../../assets/index/jx@2x.png') 100% no-repeat;
          background-size: 100% 100%;
          margin: 4px 0 3px 0;
        }

        .image-text_4 {
          width: 117px;

          .text-group_2 {
            overflow-wrap: break-word;
            color: rgba(0, 0, 0, 1);
            font-size: 16px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            text-align: left;
            white-space: nowrap;
            line-height: 22px;
          }

          .section_3 {
            width: 16px;
            height: 15px;
            background: url('../../assets/index/jx@2x.png') 100% no-repeat;
            background-size: 100% 100%;
            margin: 4px 0 3px 0;
          }
        }
      }

      .image_5 {
        position: absolute;
        left: 70px;
        top: 12px;
        width: 234px;
        height: 132px;
      }
    }

    .section_4 {
      background-color: rgba(255, 255, 255, 1);
      border-radius: 12px;
      margin: -1px 13px 0 12px;
      padding: 19px 12px 19px 19px;

      .box_15 {
        .box_2 {
          background-color: rgba(255, 255, 255, 1);
          border-radius: 12px;
          position: relative;
          border: 0.01rem solid gray;
          padding: 7px 30px 8px 114px;

          .text-group_9 {
            margin-left: 1px;

            .text_4 {
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 20px;
              margin-right: 33px;
            }

            .text_5 {
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 11px;
              font-weight: normal;
              text-align: left;
              white-space: nowrap;
              line-height: 16px;
              margin-top: 4px;
            }
          }

          .text-wrapper_1 {
            background: linear-gradient(90deg, #FFBB6B 0%, red 100%);
            border-radius: 0.4rem;
            background-size: 100% 100%;
            margin: 14px 93px 0 0;
            padding: 10px 16px 10px 16px;

            .text_6 {
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 12px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              white-space: nowrap;
              line-height: 12px;
            }
          }

          .box_3 {
            height: 110px;
            background-size: 100% 100%;
            width: 110px;
            position: absolute;
            left: -6px;
            top: -7px;

            .section_5 {
              background: url('../../assets/index/index_shop@2x.png') 100% no-repeat;
              background-size: 100% 100%;
              padding: 0 27px 80px 0;

              .text-wrapper_2 {
                background-size: 100% 100%;
                padding: 2px 28px 11px 19px;

                .text_7 {
                  overflow-wrap: break-word;
                  color: rgba(237, 51, 36, 1);
                  font-size: 12px;
                  font-family: PingFangSC-Medium;
                  font-weight: 500;
                  text-align: center;
                  white-space: nowrap;
                  line-height: 17px;
                }
              }
            }
          }
        }

        .box_4 {
          background-color: rgba(255, 255, 255, 1);
          border-radius: 12px;
          position: relative;
          border: 0.01rem solid gray;
          margin-top: 19px;
          padding: 6px 27px 7px 114px;

          .text-group_10 {
            margin-left: 1px;

            .text_8 {
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 20px;
              margin-right: 36px;
            }

            .text_9 {
              width: 175px;
              height: 28px;
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 11px;
              font-weight: normal;
              text-align: left;
              line-height: 14px;
              margin-top: 4px;
            }
          }

          .text-wrapper_3 {
            background: linear-gradient(90deg, #FFBB6B 0%, red 100%);
            border-radius: 0.4rem;
            background-size: 100% 100%;
            margin: 4px 96px 0 0;
            padding: 10px 16px 10px 16px;

            .text_10 {
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 12px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              white-space: nowrap;
              line-height: 12px;
            }
          }

          .section_6 {
            height: 110px;
            background-size: 100% 100%;
            width: 110px;
            position: absolute;
            left: -6px;
            top: -7px;
            padding: 24px 22px 8px 22px;

            .image_6 {
              width: 66px;
              height: 78px;
            }

            .box_5 {
              height: 110px;
              background: url('../../assets/index/index_cx@2x.png') 100% no-repeat;
              background-size: 100% 100%;
              width: 110px;
              position: absolute;
              left: 0;
              top: 0;
              padding: 0 27px 80px 0;

              .text-wrapper_4 {
                background-size: 100% 100%;
                padding: 2px 28px 11px 19px;

                .text_11 {
                  overflow-wrap: break-word;
                  color: rgba(71, 185, 130, 1);
                  font-size: 12px;
                  font-family: PingFangSC-Medium;
                  font-weight: 500;
                  text-align: center;
                  white-space: nowrap;
                  line-height: 17px;
                }
              }
            }
          }
        }

        .box_6 {
          background-color: rgba(255, 255, 255, 1);
          border-radius: 12px;
          position: relative;
          border: 0.01rem solid gray;
          margin-top: 19px;
          padding: 6px 27px 6px 114px;

          .text-group_11 {
            margin-left: 1px;

            .text_12 {
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 20px;
              margin-right: 8px;
            }

            .text_13 {
              width: 175px;
              height: 28px;
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 11px;
              font-weight: normal;
              text-align: left;
              line-height: 14px;
              margin-top: 4px;
            }
          }

          .text-wrapper_5 {
            background: linear-gradient(90deg, #FFBB6B 0%, red 100%);
            border-radius: 0.4rem;
            background-size: 100% 100%;
            margin: 5px 96px 0 0;
            padding: 10px 16px 10px 16px;

            .text_14 {
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 12px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              white-space: nowrap;
              line-height: 12px;
            }
          }

          .group_6 {
            height: 110px;
            background-size: 100% 100%;
            width: 110px;
            position: absolute;
            left: -6px;
            top: -7px;

            .box_7 {
              background: url('../../assets/index/index_jf@2x.png') 100% no-repeat;
              background-size: 100% 100%;
              padding: 0 27px 80px 0;

              .text-wrapper_13 {
                background-size: 100% 100%;
                padding: 2px 14px 11px 9px;

                .text_15 {
                  overflow-wrap: break-word;
                  color: rgba(47, 102, 237, 1);
                  font-size: 12px;
                  font-family: PingFangSC-Medium;
                  font-weight: 500;
                  text-align: center;
                  white-space: nowrap;
                  line-height: 17px;
                }
              }
            }
          }
        }

        .box_8 {
          background-color: rgba(255, 255, 255, 1);
          border-radius: 12px;
          position: relative;
          border: 0.01rem solid gray;
          margin-top: 19px;
          padding: 7px 28px 8px 114px;

          .text-group_12 {
            margin-left: 1px;

            .text_16 {
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 20px;
              margin-right: 35px;
            }

            .text_17 {
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 11px;
              font-weight: normal;
              text-align: left;
              white-space: nowrap;
              line-height: 14px;
              margin-top: 4px;
            }
          }

          .text-wrapper_7 {
            background: linear-gradient(90deg, #FFBB6B 0%, red 100%);
            border-radius: 0.4rem;
            background-size: 100% 100%;
            margin: 16px 95px 0 0;
            padding: 10px 16px 10px 16px;

            .text_18 {
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 12px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              white-space: nowrap;
              line-height: 12px;
            }
          }

          .block_3 {
            height: 110px;
            background-size: 100% 100%;
            width: 110px;
            position: absolute;
            left: -6px;
            top: -7px;

            .section_7 {
              background: url('../../assets/index/index_food.@2x.png') 100% no-repeat;
              background-size: 100% 100%;
              padding: 0 27px 80px 0;

              .text-wrapper_8 {
                background-size: 100% 100%;
                padding: 2px 28px 11px 19px;

                .text_19 {
                  overflow-wrap: break-word;
                  color: rgba(255, 159, 69, 1);
                  font-size: 12px;
                  font-family: PingFangSC-Medium;
                  font-weight: 500;
                  text-align: center;
                  white-space: nowrap;
                  line-height: 17px;
                }
              }
            }
          }
        }

        .box_9 {
          background-color: rgba(255, 255, 255, 1);
          border-radius: 12px;
          position: relative;
          border: 0.01rem solid gray;
          margin-top: 19px;
          padding: 5px 59px 8px 114px;

          .text-group_13 {
            margin-left: 1px;

            .text_20 {
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 20px;
              margin-right: 84px;
            }

            .text_21 {
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 11px;
              font-weight: normal;
              text-align: left;
              white-space: nowrap;
              line-height: 14px;
              margin-top: 4px;
            }
          }

          .text-wrapper_9 {
            background: linear-gradient(90deg, #FFBB6B 0%, red 100%);
            border-radius: 0.4rem;
            background-size: 100% 100%;
            margin: 18px 64px 0 0;
            padding: 10px 16px 10px 16px;

            .text_22 {
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 12px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              white-space: nowrap;
              line-height: 12px;
            }
          }

          .block_4 {
            height: 110px;
            background-size: 100% 100%;
            width: 110px;
            position: absolute;
            left: -6px;
            top: -7px;

            .text-wrapper_10 {
              background: url('../../assets/index/index_20@2x.png') 100% no-repeat;
              background-size: 100% 100%;
              padding: 2px 49px 91px 13px;

              .text_23 {
                overflow-wrap: break-word;
                color: rgba(255, 235, 191, 1);
                font-size: 12px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                text-align: center;
                white-space: nowrap;
                line-height: 17px;
              }
            }
          }
        }

        .box_10 {
          background-color: rgba(255, 255, 255, 1);
          border-radius: 12px;
          position: relative;
          border: 0.01rem solid gray;
          margin-top: 19px;
          padding: 5px 59px 8px 114px;

          .text-group_14 {
            margin-left: 1px;

            .text_24 {
              overflow-wrap: break-word;
              color: rgba(51, 51, 51, 1);
              font-size: 14px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              white-space: nowrap;
              line-height: 20px;
              margin-right: 84px;
            }

            .text_25 {
              overflow-wrap: break-word;
              color: rgba(153, 153, 153, 1);
              font-size: 11px;
              font-weight: normal;
              text-align: left;
              white-space: nowrap;
              line-height: 14px;
              margin-top: 4px;
            }
          }

          .text-wrapper_11 {
            background: linear-gradient(90deg, #FFBB6B 0%, red 100%);
            border-radius: 0.4rem;
            background-size: 100% 100%;
            margin: 18px 64px 0 0;
            padding: 10px 16px 10px 16px;

            .text_26 {
              overflow-wrap: break-word;
              color: rgba(255, 255, 255, 1);
              font-size: 12px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              text-align: left;
              white-space: nowrap;
              line-height: 12px;
            }
          }

          .box_11 {
            height: 110px;
            background-size: 100% 100%;
            width: 110px;
            position: absolute;
            left: -6px;
            top: -7px;

            .text-wrapper_12 {
              background: url('../../assets/index/index_50@2x.png') 100% no-repeat;
              background-size: 100% 100%;
              padding: 2px 49px 91px 13px;

              .text_27 {
                overflow-wrap: break-word;
                color: rgba(255, 235, 191, 1);
                font-size: 12px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                text-align: center;
                white-space: nowrap;
                line-height: 17px;
              }
            }
          }
        }
      }
    }
  }
}

body * {
  box-sizing: border-box;
  //flex-shrink: 0;
}


body {
  font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
  Arial, PingFang SC-Light, Microsoft YaHei;
  background: linear-gradient(180deg, #CEE9FC, #FF6F95) 100% no-repeat

}


input {
  background-color: transparent;
  border: 0;
}

button {
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  outline: none;
  background-color: transparent;
}

button:active {
  opacity: 0.6;
}

.van-nav-bar__left:active,
.van-nav-bar__right:active {
  opacity: 1;
}

[class*='van-']::after {
  border-bottom: 0;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.justify-start {
  display: flex;
  justify-content: flex-start;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.justify-end {
  display: flex;
  justify-content: flex-end;
}

.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}

.justify-around {
  display: flex;
  justify-content: space-around;
}

.justify-between {
  display: flex;
  //justify-content: space-between;
}

.align-start {
  display: flex;
  align-items: flex-start;
}

.align-center {
  display: flex;
  align-items: center;
}

.align-end {
  display: flex;
  align-items: flex-end;
}

</style>
